<template>
  <svg v-if="isHover" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 26 24">
    <defs>
      <path id="a" d="M0 0h25.555v23.34H0z" />
      <path id="c" d="M0 23.34h25.555V0H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M2.866 22.635H23.04s1.83.13 1.774-2.406l-10.309-18.5s-1.329-2.274-3.603 0L1.037 19.854s-1.33 2.781 1.83 2.781"
        fill="#E91545"
      />
      <mask id="b" fill="#fff">
        <use xlink:href="#a" />
      </mask>
      <path
        d="M25.239 19.56 15.219 1.39C14.749.53 13.809 0 12.779 0s-1.97.53-2.44 1.39L.309 19.56c-.44.81-.41 1.76.09 2.54.51.77 1.39 1.24 2.35 1.24h4.75c.39 0 .71-.32.71-.71 0-.38-.32-.7-.71-.7h-4.75c-.44 0-.83-.21-1.06-.57-.24-.35-.25-.77-.05-1.15l10.03-18.17c.22-.4.63-.63 1.11-.63.47 0 .89.23 1.11.63l10.02 18.17c.21.38.19.8-.04 1.15-.23.36-.62.57-1.07.57h-4.75c-.39 0-.7.32-.7.7 0 .39.31.71.7.71h4.75c.97 0 1.85-.47 2.35-1.24.51-.78.54-1.73.09-2.54"
        fill="#D92043"
        mask="url(#b)"
      />
      <mask id="d" fill="#fff">
        <use xlink:href="#c" />
      </mask>
      <path fill="#FFF" mask="url(#d)" d="M11.978 16.543h1.6V8.052h-1.6zm0 2.852h1.6v-1.41h-1.6z" />
      <path
        d="M18.759 22.63a.704.704 0 1 1-1.41 0c0-.38.31-.7.7-.7.39 0 .71.32.71.7m-10.55 0a.704.704 0 1 1-1.41 0c0-.38.31-.7.7-.7.39 0 .71.32.71.7"
        fill="#D92043"
        mask="url(#d)"
      />
      <path fill="#D92043" mask="url(#d)" d="M6.136 23.34H20.38v-1.41H6.136z" />
    </g>
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 26 24">
    <defs>
      <path id="a" d="M0 0h25.555v23.34H0z" />
      <path id="c" d="M0 23.34h25.555V0H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M2.866 22.635H23.04s1.83.13 1.774-2.406l-10.309-18.5s-1.329-2.274-3.603 0L1.037 19.854s-1.33 2.781 1.83 2.781"
        fill="#FEFEFE"
      />
      <mask id="b" fill="#fff">
        <use xlink:href="#a" />
      </mask>
      <path
        d="M25.239 19.56 15.219 1.39C14.749.53 13.809 0 12.779 0s-1.97.53-2.44 1.39L.309 19.56c-.44.81-.41 1.76.09 2.54.51.77 1.39 1.24 2.35 1.24h4.75c.39 0 .71-.32.71-.71 0-.38-.32-.7-.71-.7h-4.75c-.44 0-.83-.21-1.06-.57-.24-.35-.25-.77-.05-1.15l10.03-18.17c.22-.4.63-.63 1.11-.63.47 0 .89.23 1.11.63l10.02 18.17c.21.38.19.8-.04 1.15-.23.36-.62.57-1.07.57h-4.75c-.39 0-.7.32-.7.7 0 .39.31.71.7.71h4.75c.97 0 1.85-.47 2.35-1.24.51-.78.54-1.73.09-2.54"
        fill="#D92043"
        mask="url(#b)"
      />
      <mask id="d" fill="#fff">
        <use xlink:href="#c" />
      </mask>
      <path
        fill="#D92043"
        mask="url(#d)"
        d="M11.978 16.543h1.6V8.052h-1.6zm0 2.852h1.6v-1.41h-1.6zm6.781 3.235a.704.704 0 1 1-1.41 0c0-.38.31-.7.7-.7.39 0 .71.32.71.7m-10.55 0a.704.704 0 1 1-1.41 0c0-.38.31-.7.7-.7.39 0 .71.32.71.7"
      />
      <path fill="#D92043" mask="url(#d)" d="M6.136 23.34H20.38v-1.41H6.136z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Warning',
  props: {
    isHover: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style lang="scss" scope></style>
